import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-selected-img',
  templateUrl: './order-image-viewer.component.html',
  styleUrls: ['./order-image-viewer.component.css']
})
export class OrderImageViewerComponent {
  selectedImage: any;

  @Input() title: string;
  @Input() message: string;
  @Input() images: any[];
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  currentId: any = 0;

  constructor(
    private activeModal: NgbActiveModal,
    public _sanitize: DomSanitizer,
    private activeRoute: ActivatedRoute,
    public _DomSanitizationService: DomSanitizer,
    private commonServ: CommonService
  ) {}

  nextImage() {
    this.currentId = parseInt(this.currentId) + 1;
    this.selectedImage = this.images[this.currentId];
  }

  prevImage() {
    this.currentId = parseInt(this.currentId) - 1;
    this.selectedImage = this.images[this.currentId];
  }

  ngOnInit() {
    this.selectedImage = this.images[this.currentId];
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  closeModal() {
    this.activeModal.close();
  }
}

